/**
 * @file Navigation switch for PPD / entitiled photo viewers.
 */

import React from 'react';
import PropTypes from 'prop-types';

import Alert from '../global/Alert';
import ButtonGroup from '../global/ButtonGroup';

const propTypes = {
  albumId: PropTypes.string.isRequired,
  activeTab: PropTypes.oneOf(['entitled', 'ppd']),
};

const PhotoViewerSwitch = ({ albumId, activeTab }) => (
  <Alert global type="gray" className="py-1 px-1">
    <ButtonGroup
      currentValue={activeTab}
      options={[
        {
          text: 'All Matches',
          value: 'ppd',
          props: {
            to: `/purchase/album/${albumId}`,
          },
        },
        {
          text: 'Purchased',
          value: 'entitled',
          props: {
            to: `/view/album/${albumId}`,
          },
        },
      ]}
    />
  </Alert>
);

PhotoViewerSwitch.propTypes = propTypes;

export default PhotoViewerSwitch;
